import { ShareScreenBase } from "./share-screen-base"
import { getDeeplinkUrl } from "~/common/platform"
import { getMetaContent } from "~/common/get-meta-content"
import { VerificationLink } from "~/__generated__/graphql"
import appPreviewImage from "~/images/landing/app-preview-image"
import { useDocumentTitleDescription } from "~/common/use-document-title"
import { AppText } from "~/ui/app-text"

export const InviteScreen = (): JSX.Element => {
  const appEnvironment = getMetaContent<string>("APP_ENVIRONMENT")
  const deeplinkUrl = getDeeplinkUrl(appEnvironment, "home")
  useDocumentTitleDescription(
    "ChatBCC: You're invited to skip the waitlist",
    "Amazing people having real conversations about topics you love. Follow your favorites or start your own."
  )

  return (
    <ShareScreenBase
      verificationLinkType={VerificationLink.InviteFriend}
      deeplinkUrl={deeplinkUrl}
      className="justify-center"
      renderContent={() => (
        <div className="flex flex-col items-center justify-center md:my-[-24px]">
          <AppText
            variant="body2-medium"
            className="max-w-[400px] px-4 py-2 text-center text-base-white md:max-w-[600px] md:text-18"
          >
            Epic group chats hosted by your favorite podcasters, politicos, reality stars, athletes,
            comedians & more.
          </AppText>
          <img src={appPreviewImage.src} alt="App Preview" className="w-full md:max-w-[800px]" />
        </div>
      )}
    />
  )
}

export default InviteScreen
